export const APP_CONFIG = {
  address: '15750 S Bell Road Suite 2D, Homer Glen, Illinois 60491',
  telNo: '+17087377136',
  telNoFormatted: '708-737-7136',
  mapLink: 'https://goo.gl/maps/AuehZUkA7UsBthqb8'
}